module.exports = __webpack_public_path__ + "img/玩偶.318db346.png";